import { render } from "./VisuallyHidden.vue?vue&type=template&id=f9988a72"
import script from "./VisuallyHidden.vue?vue&type=script&lang=js"
export * from "./VisuallyHidden.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__